import React, {useContext} from 'react';
import IconBase from './IconBase';
import {BrandContext} from "../BrandContext";

const TryItIcon = props => {
    const brandConfig = useContext(BrandContext);
    return (
        <IconBase {...props} defaultTooltipTitle={brandConfig.walkthroughName} useTag={'<use xlink:href="#tryit-icon"/>'} viewBox={'0 0 128 128'}>
        </IconBase>
    )
}

export default TryItIcon;